import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import FirstCard from './FirstCard';
import SecondCard from './SecondCard';
import HeroContext from '../../PageContext';
import RightPolygons from './RightPolygons';
import LeftPolygons from './LeftPolygons';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    marginTop: '10px',
    [theme.breakpoints.down('sm')]: {
      '& a': {
        width: '100%',
      },
    },
    [theme.breakpoints.down('480')]: {
      maxWidth: '100%',
      flexBasis: '100%',
      marginTop: props => props.variant === 'E' && '0px',
    },
  },
  rightContent: {
    zIndex: 1,
    position: 'relative',
    marginTop: '10px',
    [theme.breakpoints.down('480')]: {
      maxWidth: '100%',
      flexBasis: '100%',
      marginTop: props => props.variant === 'E' && '0px',
      padding: props => props.variant === 'E' && '0px !important',
    },
  },
  rightContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('800')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.down('650')]: {
      marginTop: '60px',
    },
    [theme.breakpoints.down('480')]: {
      marginTop: props => props.variant === 'E' && '0px',
    },
  },
}));

function FeaturedResources({ variant, otherLanguage, twoCardStyle, isTablet }) {
  const classes = useStyles({ isTablet, variant });
  const { clientInfo, featuredResources, sendMixpanelEvent } = useContext(
    HeroContext,
  );
  const { heroGraphics = 'Hide', locale } = otherLanguage
    ? clientInfo[1] || clientInfo[0]
    : clientInfo[0];
  if (_isEmpty(featuredResources)) return null;
  const showGraphics = heroGraphics === 'Show';
  const clickHandler = (title, props) => {
    sendMixpanelEvent(title, props);
  };

  return (
    <Grid
      container
      spacing={2}
      style={{
        display: 'flex',
        justifyContent: isTablet && 'end',
        marginTop: isTablet && '-250px',
      }}
    >
      <Grid
        item
        xs={12}
        sm={isTablet ? 4 : 12}
        md={isTablet ? 4 : 5}
        className={classes.root}
      >
        {showGraphics && <LeftPolygons />}
        <Grid
          container
          justifyContent={`${twoCardStyle ? 'flex-start' : 'flex-end'}`}
        >
          {(otherLanguage
            ? featuredResources[1] || featuredResources[0]
            : featuredResources[0]
          )
            .slice(0, 1)
            .map(item => (
              <FirstCard
                data={item}
                key={item.slug}
                variant={variant}
                clickHandler={clickHandler}
                locale={locale}
                otherLanguage={otherLanguage}
              />
            ))}
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={isTablet ? 12 : 7}
        className={classes.rightContent}
      >
        {showGraphics && <RightPolygons />}
        <Grid
          container
          className={classes.rightContainer}
          direction={isTablet ? 'row' : 'column'}
        >
          {(otherLanguage
            ? featuredResources[1] || featuredResources[0]
            : featuredResources[0]
          )
            .slice(1, 4)
            .map(item => (
              <SecondCard
                data={item}
                key={item.slug}
                clickHandler={clickHandler}
                variant={variant}
                locale={locale}
                otherLanguage={otherLanguage}
                isTablet={isTablet}
              />
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

FeaturedResources.propTypes = {
  variant: PropTypes.string,
  otherLanguage: PropTypes.bool,
};

export default FeaturedResources;
